export type MuiWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export enum LicenseType {
  BASIC = 0,
  EXTENDED = 1,
  FREE = 2,
}

export const licenseTypeText: { [key in LicenseType]: string } = {
  [LicenseType.FREE]: 'Free',
  [LicenseType.BASIC]: 'Basic',
  [LicenseType.EXTENDED]: 'Extended',
};

export enum StoreType {
  CONNECT = 0, // Revenue 페이지의 경우 CONNECT + MD, CP-3755 issue 참고
  MD = 1,
  GAMEWEAR = 2,
}

export const storeTypeText: { [key in StoreType]: string } = {
  [StoreType.CONNECT]: 'Connect',
  [StoreType.MD]: 'MD Store',
  [StoreType.GAMEWEAR]: 'Gamewear',
};

export type ValueOf<T> = T[keyof T];

export type CheckObjectValue = {
  [key: string | number]: boolean;
};

export type Nullable<T> = T | null;
